import { render, staticRenderFns } from "./DirectoryTile.vue?vue&type=template&id=9aa9bcfe&scoped=true&"
import script from "./DirectoryTile.vue?vue&type=script&lang=js&"
export * from "./DirectoryTile.vue?vue&type=script&lang=js&"
import style0 from "./DirectoryTile.vue?vue&type=style&index=0&id=9aa9bcfe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aa9bcfe",
  null
  
)

export default component.exports